import { compareArrays } from "./compareArrays";

export const checkArrayList = (arrayA: string[], arrayList: string[][]) => {
  arrayList.forEach((arrayB) => {
    if (!compareArrays(arrayA, arrayB)) return false;
  });
  return true;
};
